import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/icons/kizuna-logo.svg';
import _imports_1 from '@/assets/icons/twitter.svg';
import _imports_2 from '@/assets/icons/discord.svg';
import _imports_3 from '@/assets/icons/blur.png';
import _imports_4 from '@/assets/icons/opensea.svg';
import _imports_5 from '@/assets/icons/music.svg';
import _imports_6 from '@/assets/icons/music-off.svg';
import _imports_7 from '@/assets/icons/arrow-down.svg';
import _imports_8 from '@/assets/musics/piano.mp3';
const _hoisted_1 = {
  class: "menu"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "left logo-container hidden-sm-and-down"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "Kizuna"
})], -1);
const _hoisted_3 = {
  class: "middle links-container"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/mint",
  class: "link",
  target: "_blank"
}, "MINT", -1);
const _hoisted_5 = {
  class: "right hidden-xs-only"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"socials-container\"><a class=\"link\" target=\"_blank\" href=\"https://twitter.com/kizunamoe\"><img class=\"icon\" src=\"" + _imports_1 + "\" alt=\"Twitter\"></a><a class=\"link\" target=\"_blank\" href=\"https://discord.gg/WFnPv2Q7R3\"><img class=\"icon\" src=\"" + _imports_2 + "\" alt=\"Discord\"></a><a class=\"link\" target=\"_blank\" href=\"https://blur.io/collection/0x7777777Be27646dA6603804cE7202224121a2482\"><img class=\"icon blur\" src=\"" + _imports_3 + "\" alt=\"Blur\"></a><a class=\"link\" target=\"_blank\" href=\"https://opensea.io/collection/kizunagenesis\"><img class=\"icon opensea\" src=\"" + _imports_4 + "\" alt=\"Opensea\"></a></div>", 1);
const _hoisted_7 = {
  key: 0,
  class: "icon",
  src: _imports_5
};
const _hoisted_8 = {
  key: 1,
  class: "icon",
  src: _imports_6
};
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  class: "title-container"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "KIZUNA"
}, null, -1);
const _hoisted_12 = {
  key: 0,
  class: "title"
};
const _hoisted_13 = {
  class: "button-container"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, "EXPLORE", -1);
const _hoisted_16 = {
  class: "frame-decorations-container"
};
const _hoisted_17 = {
  class: "links-container"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1);
const _hoisted_19 = {
  class: "links-container"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  href: "/mint",
  target: "_blank"
}, "MINT", -1);
const _hoisted_21 = {
  class: "icon-container-wrapper"
};
const _hoisted_22 = {
  class: "icon-container"
};
const _hoisted_23 = {
  key: 0,
  class: "icon",
  src: _imports_5
};
const _hoisted_24 = {
  key: 1,
  class: "icon",
  src: _imports_6
};
const _hoisted_25 = {
  hidden: true,
  ref: "music",
  loop: ""
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_8,
  type: "audio/mp3"
}, null, -1);
const _hoisted_27 = [_hoisted_26];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingMask = _resolveComponent("LoadingMask");
  const _component_SoundSelect = _resolveComponent("SoundSelect");
  const _component_el_button = _resolveComponent("el-button");
  const _component_SunsetLayers = _resolveComponent("SunsetLayers");
  const _component_NightLayers = _resolveComponent("NightLayers");
  const _component_DayLayers = _resolveComponent("DayLayers");
  const _component_ConceptSection = _resolveComponent("ConceptSection");
  const _component_GenesisSection = _resolveComponent("GenesisSection");
  const _component_StorySection = _resolveComponent("StorySection");
  const _component_GuardiansSection = _resolveComponent("GuardiansSection");
  const _component_TeamSection = _resolveComponent("TeamSection");
  const _component_FaqFooter = _resolveComponent("FaqFooter");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.isSmallDevice && !_ctx.isPageReady || !_ctx.isSmallDevice && _ctx.remainingAssetsProgress > 0 ? (_openBlock(), _createBlock(_component_LoadingMask, {
    key: 0,
    showProgress: !_ctx.isSmallDevice,
    remainingAssetsProgress: _ctx.remainingAssetsProgress,
    onWheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    onScroll: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
  }, null, 8, ["showProgress", "remainingAssetsProgress"])) : _createCommentVNode("", true), !_ctx.hasSelectedSound ? (_openBlock(), _createBlock(_component_SoundSelect, {
    key: 1,
    onSelect: value => {
      _ctx.isMusicPlaying = value;
      _ctx.hasSelectedSound = true;
    },
    onWheel: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    onTouchmove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    onScroll: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
  }, null, 8, ["onSelect"])) : _createCommentVNode("", true), _createElementVNode("div", {
    id: "luxy",
    class: _normalizeClass(["home-container", {
      day: !_ctx.layer || _ctx.layer === 'day',
      sunset: _ctx.layer === 'sunset',
      night: _ctx.layer === 'night'
    }])
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
    class: "link concept",
    link: true,
    text: true,
    onClick: _cache[6] || (_cache[6] = () => _ctx.scrollToElement('concept-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("CONCEPT")]),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "link genesis",
    link: true,
    text: true,
    onClick: _cache[7] || (_cache[7] = () => _ctx.scrollToElement('genesis-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("GENESIS")]),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "link story",
    link: true,
    text: true,
    onClick: _cache[8] || (_cache[8] = () => _ctx.scrollToElement('story-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("STORY")]),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "link guardians",
    link: true,
    text: true,
    onClick: _cache[9] || (_cache[9] = () => _ctx.scrollToElement('guardians-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("GUARDIANS")]),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "link team",
    link: true,
    text: true,
    onClick: _cache[10] || (_cache[10] = () => _ctx.scrollToElement('team-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("TEAM")]),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "link mint",
    link: true,
    text: true
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", {
    onClick: _cache[11] || (_cache[11] =
    //@ts-ignore
    (...args) => _ctx.togglePlayMusic && _ctx.togglePlayMusic(...args)),
    class: "music"
  }, [!_ctx.isMusicPlaying ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8))])])]), _ctx.layer === 'sunset' ? (_openBlock(), _createBlock(_component_SunsetLayers, {
    key: 0,
    onRemainingLoadingAssets: _cache[12] || (_cache[12] = value => _ctx.handleLoadingAssets(value)),
    isSmallDevice: _ctx.isSmallDevice
  }, null, 8, ["isSmallDevice"])) : _ctx.layer === 'night' ? (_openBlock(), _createBlock(_component_NightLayers, {
    key: 1,
    onRemainingLoadingAssets: _cache[13] || (_cache[13] = value => _ctx.handleLoadingAssets(value)),
    isSmallDevice: _ctx.isSmallDevice
  }, null, 8, ["isSmallDevice"])) : (_openBlock(), _createBlock(_component_DayLayers, {
    key: 2,
    onRemainingLoadingAssets: _cache[14] || (_cache[14] = value => _ctx.handleLoadingAssets(value)),
    isSmallDevice: _ctx.isSmallDevice
  }, null, 8, ["isSmallDevice"])), _createElementVNode("section", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["intro luxy-el", {
      hidden: !_ctx.isTopOfPage,
      'fade-out': !_ctx.isTopOfPage,
      'fade-in': _ctx.isTopOfPage
    }]),
    "data-speed-y": "-15"
  }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _ctx.hasSelectedSound ? (_openBlock(), _createElementBlock("p", _hoisted_12)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
    class: "explore-button",
    onClick: _cache[15] || (_cache[15] = () => _ctx.scrollToElement('concept-section'))
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  }), _hoisted_15])], 2), _createElementVNode("div", {
    class: _normalizeClass(["panels-container", {
      hidden: _ctx.isTopOfPage
    }])
  }, [_createVNode(_component_ConceptSection, {
    id: "concept-section",
    class: "section",
    onClick: _cache[16] || (_cache[16] = () => !_ctx.isConceptMenuActive && _ctx.scrollToElement('concept-section'))
  }), _createVNode(_component_GenesisSection, {
    id: "genesis-section",
    class: "section",
    onClick: _cache[17] || (_cache[17] = () => !_ctx.isGenesisMenuActive && _ctx.scrollToElement('genesis-section'))
  }), _createVNode(_component_StorySection, {
    id: "story-section",
    class: "section",
    onClick: _cache[18] || (_cache[18] = () => !_ctx.isStoryMenuActive && _ctx.scrollToElement('story-section'))
  }), _createVNode(_component_GuardiansSection, {
    id: "guardians-section",
    class: "section",
    onClick: _cache[19] || (_cache[19] = () => !_ctx.isGuardiansMenuActive && _ctx.scrollToElement('guardians-section'))
  }), _createVNode(_component_TeamSection, {
    id: "team-section",
    class: "section",
    onClick: _cache[20] || (_cache[20] = () => !_ctx.isTeamMenuActive && _ctx.scrollToElement('team-section'))
  })], 2)]), _createVNode(_component_FaqFooter, {
    id: "footer"
  })], 2), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    class: _normalizeClass(["decoration corner top left hidden-md-and-down", {
      visible: !_ctx.isTopOfPage
    }])
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["decoration corner top right hidden-md-and-down", {
      visible: !_ctx.isTopOfPage
    }])
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["small-side-menu-container hidden-lg-and-up", {
      visible: !_ctx.isTopOfPage
    }])
  }, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
    class: _normalizeClass(["link concept", {
      active: _ctx.isConceptMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[21] || (_cache[21] = () => _ctx.scrollToElement('concept-section'))
  }, null, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link genesis", {
      active: _ctx.isGenesisMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[22] || (_cache[22] = () => _ctx.scrollToElement('genesis-section'))
  }, null, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link story", {
      active: _ctx.isStoryMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[23] || (_cache[23] = () => _ctx.scrollToElement('story-section'))
  }, null, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link guardians", {
      active: _ctx.isGuardiansMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[24] || (_cache[24] = () => _ctx.scrollToElement('guardians-section'))
  }, null, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link team", {
      active: _ctx.isTeamMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[25] || (_cache[25] = () => _ctx.scrollToElement('team-section'))
  }, null, 8, ["class"])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["side-menu-container hidden-md-and-down", {
      visible: !_ctx.isTopOfPage
    }])
  }, [_createVNode(_component_el_button, {
    class: "top-button",
    link: true,
    text: true,
    onClick: _cache[26] || (_cache[26] = () => _ctx.scrollToTop())
  }, {
    default: _withCtx(() => [_hoisted_18]),
    _: 1
  }), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
    class: _normalizeClass(["link concept", {
      active: _ctx.isConceptMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[27] || (_cache[27] = () => _ctx.scrollToElement('concept-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("CONCEPT")]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link genesis", {
      active: _ctx.isGenesisMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[28] || (_cache[28] = () => _ctx.scrollToElement('genesis-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("GENESIS")]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link story", {
      active: _ctx.isStoryMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[29] || (_cache[29] = () => _ctx.scrollToElement('story-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("STORY")]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link guardian", {
      active: _ctx.isGuardiansMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[30] || (_cache[30] = () => _ctx.scrollToElement('guardians-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("GUARDIANS")]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_el_button, {
    class: _normalizeClass(["link team", {
      active: _ctx.isTeamMenuActive
    }]),
    link: true,
    text: true,
    onClick: _cache[31] || (_cache[31] = () => _ctx.scrollToElement('team-section'))
  }, {
    default: _withCtx(() => [_createTextVNode("TEAM")]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_el_button, {
    class: "link mint",
    link: true,
    text: true
  }, {
    default: _withCtx(() => [_hoisted_20]),
    _: 1
  })]), _createElementVNode("div", {
    class: _normalizeClass(["moon", {
      concept: _ctx.isConceptMenuActive,
      genesis: _ctx.isGenesisMenuActive,
      story: _ctx.isStoryMenuActive,
      guardians: _ctx.isGuardiansMenuActive,
      team: _ctx.isTeamMenuActive
    }])
  }, null, 2)], 2), _createElementVNode("div", {
    class: _normalizeClass(["decoration corner bottom left hidden-md-and-down", {
      visible: !_ctx.isTopOfPage && !_ctx.displayBottomFrameDecoration
    }])
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["decoration corner bottom right hidden-md-and-down", {
      visible: !_ctx.isTopOfPage && !_ctx.displayBottomFrameDecoration
    }])
  }, null, 2), _createElementVNode("div", {
    onClick: _cache[32] || (_cache[32] =
    //@ts-ignore
    (...args) => _ctx.togglePlayMusic && _ctx.togglePlayMusic(...args)),
    class: _normalizeClass(["music decoration", {
      visible: !_ctx.isTopOfPage,
      playing: _ctx.isMusicPlaying
    }])
  }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [!_ctx.isMusicPlaying ? (_openBlock(), _createElementBlock("img", _hoisted_23)) : (_openBlock(), _createElementBlock("img", _hoisted_24))])])], 2)]), _createElementVNode("audio", _hoisted_25, _hoisted_27, 512)], 64);
}